/**
 * Header Scroll Module
 * Gère le comportement du header au scroll (cacher la topbar)
 * 
 * @package JD_Theme
 */

export function initHeaderScroll() {
  const siteHeader = document.querySelector('.site-header');
  if (!siteHeader) return;
  
  let isScrolled = false;
  const SCROLL_THRESHOLD = 50;
  
  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > SCROLL_THRESHOLD && !isScrolled) {
      siteHeader.classList.add('header-scrolled');
      isScrolled = true;
    } else if (scrollTop <= SCROLL_THRESHOLD && isScrolled) {
      siteHeader.classList.remove('header-scrolled');
      isScrolled = false;
    }
  });
}
